module.exports = __webpack_public_path__ + "static/img/vsrs.8c89cf6a.png";